import { render, staticRenderFns } from "./ComplexBackground.vue?vue&type=template&id=26770c55&scoped=true"
import script from "./ComplexBackground.vue?vue&type=script&lang=ts"
export * from "./ComplexBackground.vue?vue&type=script&lang=ts"
import style0 from "./ComplexBackground.vue?vue&type=style&index=0&id=26770c55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26770c55",
  null
  
)

export default component.exports